import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import styled from 'styled-components';

interface LoadingSpinnerProps {
    style?: React.CSSProperties;
    size?: number;
    color?: 'inherit' | 'primary' | 'secondary';
    className?: string;
}

const LoadingSpinner: React.FC<React.PropsWithChildren<LoadingSpinnerProps>> =
    ({ style, size, color, className }) => {
        return (
            <Container className={className} style={{ ...style }}>
                <CircularProgress color={color ?? 'primary'} size={size} />
            </Container>
        );
    };

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
});
export default LoadingSpinner;
